import { render, staticRenderFns } from "./ARG.vue?vue&type=template&id=ca7cd7a8&scoped=true&"
import script from "./ARG.vue?vue&type=script&lang=js&"
export * from "./ARG.vue?vue&type=script&lang=js&"
import style0 from "./ARG.vue?vue&type=style&index=0&id=ca7cd7a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7cd7a8",
  null
  
)

export default component.exports